import { inject, view } from "@spawn/core";
import { NudgingCompleteEvent, NudgingEvent } from "@spawn/nudge";
import { IReelSetOptions, ReelSetView } from "@spawn/slot-machine";
import { merge } from "rxjs";
import { GameEvents, UpdateFullReelsetEvent } from "../events/events";
import { ReelsetService } from "../services/reelsetService";

@view
export class ExtendedReelSetView extends ReelSetView {
	@inject protected readonly reelsetService!: ReelsetService;

	protected override initialize(x: Omit<IReelSetOptions, "name" | "visibleSymbols">): void {
		super.initialize(x);

		this.subscriptions.push(
			merge(
				this.eventDispatcher.event$<NudgingCompleteEvent>(NudgingEvent.Complete), // Used to update the reels while the nudging animation is playing.
				this.eventDispatcher.event$<UpdateFullReelsetEvent>(GameEvents.UpdateFullReelset)
			).subscribe(this.updateFullReelset.bind(this))
		);
	}

	protected updateFullReelset(): void {
		const reels = this.networkService.state.slotGameBase.reels;

		this.reelsetService.replaceVisibleSymbolsOnReelset(reels);
		this.replaceOffscreenSymbols(reels);
	}

	private replaceOffscreenSymbols(reels: string[][]): void {
		for (let x = 0; x < reels.length; x++) {
			const reel = reels[x];
			const reelView = this.getReelViewAtIndex(x);
			reelView.changeSymbolAtIndex(-1, reel[0]);
			reelView.changeSymbolAtIndex(reelView.visibleSymbols, reel[reel.length - 1]);
		}
	}
}
